exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2RaI8EIw7fAZAJvm7g8fAJ .box-widget{background:dycolor-internal(!background,@theme-very-light-grey)}._2RaI8EIw7fAZAJvm7g8fAJ .box-widget.box-widget--success .box-widget-badge{background:dycolor-internal(!badge-success,@theme-success)}._2RaI8EIw7fAZAJvm7g8fAJ .box-widget.box-widget--error .box-widget-badge{background:dycolor-internal(!badge-error,@theme-error)}._2RaI8EIw7fAZAJvm7g8fAJ .box-widget-head{color:dycolor-internal(!head,@primary)}._2RaI8EIw7fAZAJvm7g8fAJ .box-widget-icon{color:dycolor-internal(!badge-color,@theme-white);background:dycolor-internal(!badge-color,@primary)}._2RaI8EIw7fAZAJvm7g8fAJ .box-widget-badge{background:dycolor-internal(!background,@theme-light-grey);color:dycolor-internal(!badge-color,@theme-white)}._2RaI8EIw7fAZAJvm7g8fAJ .box-widget--color-invert .box-widget-icon{color:dycolor-internal(!head,@primary)}\n", ""]);

// exports
exports.locals = {
	"root": "_2RaI8EIw7fAZAJvm7g8fAJ"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js?colors!./~/sass-loader/lib/loader.js?outputStyle=compressed!./src/components/box-widget/BoxWidget.scss
// module id = 882
// module chunks = 1